<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col>-->
        <v-col cols="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                :disabled="selectedRows.length > 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-file-plus-outline</v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="assignRemoveFormDialog(true)"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-plus-circle-multiple-outline</v-icon>
                <span class="lable_class">Assign</span>
              </v-btn>
            </template>
            <span>Assign form(s) on selected records</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="assignRemoveFormDialog(false)"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-delete-sweep-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Remove form(s) from selected records</span>
          </v-tooltip>-->
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-7 header_btn"
              >
                <v-icon size="28px"> mdi-clipboard-edit-outline </v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>-->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-7 header_btn">
                <v-icon size="28px">mdi-eye-outline</v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                @click="delete_dialog = true"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-delete-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="5">
          <!-- <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small dark v-bind="attrs" v-on="on" class="ml-7 header_btn" >
                <span class="lable_class">Search</span>
                 <v-badge overlap dot :value="search" color="error">
                  <v-icon size="28px">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="300">
              <v-row no-gutters>
            <v-col cols="12" class="">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
                solo
                clearable
                v-on:keyup.enter="search_menu = false"
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>
            </v-card>
          </v-menu>-->
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="filter_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="pagination.filters.alphabet = ''"
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Filter</span>
                <v-icon size="22px">mdi-filter-menu-outline</v-icon>
              </v-btn>
            </template>
            <v-card tile max-width="400" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-list-item class="mt-0">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    hide-details
                    dense
                    outlined
                    placeholder=" "
                    clearable
                    autofocus
                    v-on:keyup.enter="search_menu = false"
                    class="mr-2"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="error"
                        @click="resetFilter()"
                        icon
                        small
                      >
                        <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Reset</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item class="mt-1">
                  <v-autocomplete
                    dense
                    flat
                    :items="status"
                    outlined
                    label="Status"
                    hide-details
                    class="body-2"
                    placeholder=" "
                    v-model="pagination.filters.group_active"
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="3" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Invoice Group
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card flat tile>
      <v-card-text class="pa-0 mx-auto">
        <v-row dense class="pa-0 ma-0">
          <v-col cols="12" class="pa-0 ma-0">
            <v-data-table
              :headers="headers"
              class="elevation-1 rounded-0 my-transaction-table small-table fix-table-layout fix-table-header custom-width-700"
              item-key="user_id"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              dense
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item }">
                <tr :class="(!item.group_active)?'red lighten-5':''">
                  <td width="3%">
                    <v-icon @click="editRecord(item.invoice_group_id)">mdi-clipboard-edit-outline</v-icon>
                  </td>
                  <td width="7%" class="pl-3">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td width="50%">{{item.name}}</td>
                  <!-- <td width="40%">
                    <v-autocomplete
                      style="margin-top: -1px;"
                      :items="module_list"
                      dense=""
                      v-model="modules[items.data.indexOf(item)]"
                      hide-details=""
                      multiple=""
                      @change="changeFormModule(items.data.indexOf(item),item)"
                    >
                      <template v-slot:selection="{index}">                                         
                        <span class="grey--text caption" v-if="index == 0">
                          {{selected_modules(items.data.indexOf(item))}}
                        </span>
                      </template>
                    </v-autocomplete>
                  </td>-->
                </tr>
              </template>
              <template v-slot:header.select_all>
                <v-simple-checkbox
                  v-model="select_all_checkbox"
                  @input="changeSelectAll()"
                  color="white"
                  :ripple="false"
                  class="select-all-checkbox custom-simple-box"
                ></v-simple-checkbox>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="400px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Add Invoice Group</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="Invoice Group*"
                  v-model="form_data.name"
                  :error-messages="form_error.name"
                  :hide-details="!form_error.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-textarea
                  v-model="form_data.keywords"
                  label="Keywords (comma separated)"
                  dense
                  :error-messages="form_error.keywords"
                  :hide-details="!form_error.keywords"
                  rows="1"
                ></v-textarea>
              </v-col>
              <!-- <v-col cols="12" class="mt-1">
                  <v-autocomplete
                    :items="module_list"
                    label="Form Name"
                    dense=""
                    v-model="form_data.modules"
                    :error-messages="form_error.modules"
                    :hide-details="!form_error.modules"
                    multiple=""
                  >
                    <template v-slot:selection="{ index }">
                      <span class="grey--text caption" v-if="index == 0">
                        {{selected_multi_values}}
                      </span>
                    </template>
                  </v-autocomplete>
              </v-col>-->
              <v-col cols="3" class="pa-2 pb-0">
                <v-switch
                  class="pt-0 ma-0"
                  v-model="form_data.group_active"
                  label="Active"
                  color="success"
                  dense
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="dialog = false;form_data = {};form_error = {}">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addRecord">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_dialog" persistent max-width="400px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Update Invoice Group</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="Invoice Group*"
                  v-model="edit_form_data.name"
                  :error-messages="edit_form_error.name"
                  :hide-details="!edit_form_error.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-textarea
                  v-model="edit_form_data.new_keywords"
                  label="Keywords (comma separated)"
                  dense
                  :error-messages="edit_form_error.new_keywords"
                  :hide-details="!edit_form_error.new_keywords"
                  rows="1"
                >
                  <template v-slot:prepend>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          size="22"
                          v-bind="attrs"
                          v-on="on"
                          @click="keyword_dialog = true"
                        >mdi-eye-outline</v-icon>
                      </template>
                      <span>View Exist Keyword</span>
                    </v-tooltip>
                  </template>
                </v-textarea>
              </v-col>
              <!-- <v-col cols="12" class="mt-1">
                <v-autocomplete
                  :items="module_list"
                  label="Form Name"
                  dense=""
                  v-model="edit_form_data.modules"
                  :error-messages="edit_form_error.modules"
                  :hide-details="!edit_form_error.modules"
                  multiple=""
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">
                      {{selected_multi_values2}}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>-->
              <v-col cols="3" class="pa-2 pb-0 pt-1">
                <v-switch
                  class="pt-0 ma-0"
                  v-model="edit_form_data.group_active"
                  label="Active"
                  color="success"
                  dense
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="edit_dialog = false;edit_form_data = {};edit_form_error = {}"
          >Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateRecord" dark>Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected invoice groups?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteRecords()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="keyword_dialog" max-width="350" persistent>
      <v-card class="mx-auto align-self-stretch" tile :loading="keyword_loading" width="100%">
        <v-card-title class="headline pa-2">Keyword(s)</v-card-title>
        <v-card-text class="pa-2 pt-0" style="font-weight: 500;">
          <v-row
            dense
            v-if="edit_form_data.keywords && edit_form_data.keywords.length > 0"
            class="light-green lighten-4 primary--text"
          >
            <v-col
              cols="12"
              class="pt-2"
              v-for="(keyword, index) in edit_form_data.keywords"
              :key="index"
            >
              <v-btn
                class="mx-2"
                fab
                dark
                x-small
                width="22"
                height="22"
                color="primary"
                @click="deleteKeyword(keyword)"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
              <span class="ml-2">{{ keyword.title }}</span>
            </v-col>
          </v-row>
          <v-row dense v-else>
            <v-col cols="12">No Any Eixst Keyword!</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" dark @click="keyword_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="assign_remove_form_dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">{{(is_assign_form)?'Assign Form(s)':'Remove Form(s)'}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete
                  :items="module_list"
                  label="Form Name"
                  dense=""
                  v-model="selected_forms"
                  hide-details
                  multiple=""
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">
                      {{selected_multi_values3}}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="assign_remove_form_dialog = false;selected_forms = [];">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="selected_forms.length == 0" @click="assignRemoveForms"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>-->
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams, getAlphabets, logout } from "../../plugins/helper";
import { mapState, mapMutations } from "vuex";
export default {
  name: "InvoiceGroup",
  data() {
    return {
      open_doc_model_falg: false,
      filter_menu: false,
      modules: [],
      dialog: false,
      edit_dialog: false,
      delete_dialog: false,
      keyword_dialog: false,
      keyword_loading: false,
      is_assign_form: null,
      selected_forms: [],
      assign_remove_form_dialog: false,
      form_data: {
        group_active: true
      },
      form_error: {},
      edit_form_data: {
        group_active: true
      },
      edit_form_error: {},
      search: "",
      invoice_group_id: null,
      form_loading: false,
      loading: false,
      items: {
        data: []
      },
      select_all_checkbox: false,
      headers: [
        { value: "", text: "", sortable: false, class: "", width: "5%" },
        {
          value: "select_all",
          text: "",
          sortable: false,
          width: "7%",
          class: "pl-1"
        },
        { value: "name", text: "Invoice Group", sortable: true, width: "50%" }
        // { value: "", text: "Form Name", sortable: false, width:"40%" },
      ],
      module_list: [
        { value: "COUNTERTOP_ORDER", text: "Countertop Order" },
        { value: "ITEM_MASTER", text: "Item Master" },
        { value: "STONE_MASTER", text: "Stone Master" }
      ],
      status: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],

      // headers: [
      //   { value: "", text: "", sortable: false, class:'pl-3', width: '7%' },
      //   { value: "checkbox", text: "#", sortable: false, width: '7%' },
      //   { value: "name", text: "Invoice Group", sortable: false, width: '86%' },
      // ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["name"],
        page: 1,
        filters: {
          group_active: "1",
          alphabet: ""
        }
      },
      alphabets: getAlphabets(),
      expanded: [],
      search_menu: false
    };
  },
  components: {},
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    selected_multi_values3() {
      let return_data = "";
      if (this.selected_forms.length > 0) {
        this.module_list.filter(item => {
          if (item.value == this.selected_forms[0]) {
            return_data = item.text;
          }
        });
        if (this.selected_forms.length > 1) {
          let totalVen = this.selected_forms.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    },
    selected_multi_values() {
      let return_data = "";
      if (this.form_data.modules.length > 0) {
        this.module_list.filter(item => {
          if (item.value == this.form_data.modules[0]) {
            return_data = item.text;
          }
        });
        if (this.form_data.modules.length > 1) {
          let totalVen = this.form_data.modules.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    },
    selected_multi_values2() {
      let return_data = "";
      if (this.edit_form_data.modules.length > 0) {
        this.module_list.filter(item => {
          if (item.value == this.edit_form_data.modules[0]) {
            return_data = item.text;
          }
        });
        if (this.edit_form_data.modules.length > 1) {
          let totalVen = this.edit_form_data.modules.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    },
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "name";
      return paginationData;
    }
  },
  watch: {
    search() {
      this.getRecords();
    },
    pagination: {
      handler: function() {
        this.getRecords();
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    changeSelectAll() {
      if (this.select_all_checkbox) {
        this.items.data = this.items.data.map(item => {
          item.selected = true;
          return item;
        });
      } else {
        this.items.data = this.items.data.map(item => {
          item.selected = false;
          return item;
        });
      }
    },
    assignRemoveForms() {
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.invoice_group_id);
      });
      let _self = this;
      _self.form_loading = true;
      axios
        .post("assign_remove_group_form", {
          forms: this.selected_forms,
          is_assign_form: this.is_assign_form,
          ids: ids
        })
        .then(() => {
          _self.form_loading = false;
          _self.assign_remove_form_dialog = false;
          _self.getRecords();
        })
        .catch(function() {
          _self.form_loading = false;
        });
    },
    assignRemoveFormDialog(is_assign_form) {
      this.is_assign_form = is_assign_form;
      this.selected_forms = [];
      this.assign_remove_form_dialog = true;
    },
    deleteKeyword(keyword) {
      this.keyword_loading = true;
      let _self = this;
      axios
        .post("delete_keyword", keyword)
        .then(response => {
          if (response.data.status) {
            _self.edit_form_data.keywords = _self.edit_form_data.keywords.filter(
              function(eKeyword) {
                return eKeyword.keyword_id != keyword.keyword_id;
              }
            );
          }
        })
        .catch(function() {})
        .then(function() {
          _self.keyword_loading = false;
        });
    },
    editRecord(invoice_group_id) {
      this.invoice_group_id = invoice_group_id;
      this.edit_dialog = true;
      this.getDetails(invoice_group_id);
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    changeFormModule(index, item) {
      let _self = this;
      this.loading = true;
      let data = {};

      data.invoice_group_id = item.invoice_group_id;
      data.name = item.name;
      data.modules = this.modules[index];
      axios
        .post("update_invoice_group", data)
        .then(() => {
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    selected_modules(index) {
      let selected_modules = this.modules[index];
      let return_data = "";
      if (selected_modules.length > 0) {
        this.module_list.filter(item => {
          if (item.value == selected_modules[0]) {
            return_data = item.text;
          }
        });
        if (selected_modules.length > 1) {
          let totalVen = selected_modules.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      console.log("return_data", return_data);
      return return_data;
    },
    getModuleName(module_code) {
      let module_name = "";
      module_code.filter(item => {
        this.module_list.filter(item2 => {
          if (item2.value == item.form_code) {
            if (module_name) {
              module_name = module_name + ", " + item2.text;
            } else {
              module_name = item2.text;
            }
          }
        });
      });
      return module_name;
    },
    getRecords() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios
        .get("invoice_group_list?" + url)
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          let item_data = _self.items.data;
          for (let key in item_data) {
            _self.modules[key] = [];
            for (let key2 in item_data[key].modules) {
              _self.modules[key].push(item_data[key].modules[key2].form_code);
            }
          }
          console.log("module", _self.modules);
          _self.select_all_checkbox = false;
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    addRecord() {
      let _self = this;
      _self.form_loading = true;
      axios
        .post("add_invoice_group", _self.form_data)
        .then(response => {
          _self.form_data = {};
          _self.form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.form_loading = false;
            _self.dialog = false;
            _self.getRecords();
          }
        })
        .catch(function() {
          _self.form_loading = false;
        });
    },
    updateRecord() {
      let _self = this;
      _self.edit_form_data.invoice_group_id = _self.invoice_group_id;
      console.log(_self.edit_form_data);
      axios
        .post("update_invoice_group", _self.edit_form_data)
        .then(response => {
          _self.edit_form_data = {};
          _self.edit_form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.edit_form_error[key] = data.errors[key][0];
            }
          } else {
            _self.edit_form_data = {};
            _self.form_loading = false;
            _self.edit_dialog = false;
            _self.getRecords();
          }
        })
        .catch(function() {
          _self.form_loading = false;
        });
    },
    getDetails(invoice_group_id) {
      let _self = this;
      _self.form_loading = true;
      axios
        .get("get_invoice_group_details?invoice_group_id=" + invoice_group_id)
        .then(response => {
          let data = response.data.data;
          _self.edit_form_data.name = response.data.data.name;
          _self.edit_form_data.keywords = response.data.data.keywords;
          _self.edit_form_data.modules = [];
          _self.edit_form_data.group_active = response.data.data.group_active;
          for (let key in data.modules) {
            _self.edit_form_data.modules.push(data.modules[key].form_code);
          }
          console.log("edit_form_data", _self.edit_form_data.modules);
          _self.form_loading = false;
        })
        .catch(function() {
          _self.form_loading = false;
        });
    },
    deleteRecords() {
      let _self = this;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.invoice_group_id);
      });
      axios
        .post("delete_invoice_groups", {
          ids: ids
        })
        .then(function(response) {
          _self.setAlert({
            show: true,
            variant: response.data.variant,
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.getRecords();
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    logout() {
      logout(this.$router);
    }
  },
  mounted() {
    this.getRecords();
  }
};
</script>